<h5 class="mb-3">{{dailyPrediction().date | dateParse | dateFormat: 'ddd, D MMM'}}</h5>
<div>
  <canvas baseChart
          [datasets]="chartData"
          [labels]="chartLabels"
          [type]="'bar'"
          [options]="chartOptions"
  ></canvas>
</div>
